import RoutePath from "./routes";
import "./globals/utilities.css";
import "./globals/typography.css";
import "react-phone-number-input/style.css";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution } from "./utils/attribution";
import FullScreenLoader from "./components/Loaders/FullScreen/loader";
import { companyProfile } from "./services/clientCalls";
import { UserContext } from "./context";
import { talentProfile } from "./services/talentCalls";
import UseScrollToTop from "./hooks/useScrollToTop";
import "./config/axios"
import { HelmetProvider } from "react-helmet-async";
import Chatbox from "./components/Chatbox/chatbox";
import CookieConsent from "./components/CookieConsent/CookieConsent";
import { DocumentHeader } from "./components/Seo";

const App = () => {
  const [auth, setAuth] = useState(false);
  const [data, setData] = useState({});
  const [load, setLoad] = useState(false);
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(1);
  const [role, setRole] = useState("talent");
  const [skillModal, setSkillModal] = useState(false);
  // Production answers on www.awasource.com (awasource.com redirects there).
  // Anything else (localhost, dev, staging) gets the dev-only features.
  const isDev = !["awasource.com", "www.awasource.com"].includes(window.location.hostname);
  const GOOGLE_API_KEY =  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
  const location = useLocation();

  useEffect(() => {
    captureAttribution();
  }, [location.search]);

  useEffect(() => {
    window.scrollTo(0, 0);

  }, []);


  return (
    <HelmetProvider>
      <DocumentHeader />
      <UseScrollToTop>
        <UserContext.Provider
          value={{ data, setData, auth, setCount, role, setRole, search, setSearch, skillModal, setSkillModal, isDev, GOOGLE_API_KEY }}
        >
          {!!load ? <FullScreenLoader /> : <RoutePath />}
          <CookieConsent />
          {/* "Talk to Stan" support chat: on dev/staging hosts, and on
              awasource.com once REACT_APP_ENABLE_STAN=true is set. */}
          {(isDev || process.env.REACT_APP_ENABLE_STAN === "true") &&
            <div className="fixed bottom-4 right-4 z-50">
              <Chatbox />
            </div>
          }
        </UserContext.Provider>
      </UseScrollToTop>
    </HelmetProvider>
  );
};

export default App;
// {
//   /* 1. We're not collecting certificate and portfolio,
//       2. We're not showing min and max salary desired.
//       3. Should we show their uploades video here?
//       4. We didn't collect profile pictures
//       5. There's no palce for clients to chnage their social media links.
//       6. Support page.
//       7. Where's the link toclient team & user management?
//       8. No messages on talent's end.
//       9. Responsibilites and Objectives when creating a job seems the same.
//       10. Talents cannot upload profile pictures.
//       11. We're not veryfying client phone number.
//       */
// }
